// Omnix/common/schemas/collections/omniInteractions.js
import { z } from "zod";

const OmniInteractionSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    conversationId: z.string().describe("Foreign key to the omniConversations collection."),
    subscriptionId: z.string().describe("The subscription this interaction belongs to."),

    timestamp: z.coerce.date().describe("The exact time of the interaction."),

    channelType: z.enum(["email", "sms", "whatsapp", "voice", "web_chat", "form", "internal_note", "system_event", "facebook_messenger", "instagram", "telegram"])
        .describe("The channel through which this interaction occurred."),

    direction: z.enum(["inbound", "outbound"]).describe("The direction of the communication."),

    senderId: z.string().describe("The omniContactId (for inbound) or userId (for outbound) of the sender."),

    payload: z.record(z.any()).describe("A flexible object containing channel-specific data (e.g., email subject, call duration)."),

    attachments: z.array(z.object({
        fileId: z.string(),
        fileName: z.string().optional().nullable(), // Make fileName optional
        mimeType: z.string().optional(),
        size: z.number().optional(),
    })).optional().default([]),

    readBy: z.array(z.object({
        userId: z.string(), // Changed from contactId to userId
        readAt: z.coerce.date(),
    })).optional().default([]),
    
    status: z.enum(["sending", "sent", "delivered", "read", "failed"]).optional().nullable()
        .describe("Delivery status for outbound messages."),
});

export default OmniInteractionSchema;